<template>
  <v-select
    :clearable="multiple"
    :close-on-select="!multiple"
    :filterable="false"
    label="id"
    :multiple="multiple"
    :options="options"
    placeholder="Select Challenge"
    :value="value"
    @input="$emit('input', $event)"
    @search="searchChallengesHandler"
  >
    <template slot="no-options">
      <div class="content select-hint">
        <span v-if="query">
          No matching results
        </span>
        <span v-else>
          Type to search challenges...
        </span>
      </div>
    </template>
    <template slot="option" slot-scope="option">
      <div class="content option">
        <div class="is-size-6">
          {{ option.name }}
        </div>
        <div class="related-topics">
          <b-tag v-for="topicName in option.relatedTopicNames" :key="topicName">
            {{ topicName }}
          </b-tag>
        </div>
      </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div class="content option">
        <div class="is-size-6">
          {{ option.name }}
        </div>
        <div class="related-topics">
          <b-tag v-for="topicName in option.relatedTopicNames" :key="topicName">
            {{ topicName }}
          </b-tag>
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    multiple: Boolean,
    value: {
      type: [Object, Array],
      default: null,
      required: false
    },
    excludeIf: Function
  },
  data: function() {
    return {
      options: [],
      query: ''
    };
  },
  methods: {
    searchChallengesHandler(search, loading) {
      loading(true);
      this.searchChallenge(search, loading);
    },
    searchChallenge: debounce(function(search, loading) {
      this.query = search;
      const index = this.$searchClient.initIndex('challenges');
      index.search(
        {
          query: search,
          hitsPerPage: 5
        },
        (error, data) => {
          if (error) {
            this.$buefy.toast.open({
              message: 'Failed to search for challeges!',
              type: 'is-danger'
            });
          } else {
            let results = data.hits.map(hit => ({
              id: hit.objectID,
              name: hit.name,
              relatedTopicNames: hit.relatedTopicNames
            }));
            if (this.excludeIf)
              results = results.filter(hit => !this.excludeIf(hit.id));
            this.options = results;
          }
          loading(false);
        }
      );
    }, 400)
  }
};
</script>

<style lang="scss" scoped>
.select-hint {
  padding: 0.5rem;
}
.option {
  .related-topics {
    margin-top: 0.4rem;

    .tag:not(:first-child) {
      margin-left: 0.4rem;
    }
  }
}
</style>
